'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dOystr$002dAdmin$002dPage$0024 from "./presto.-Oystr-Admin-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489 from "./presto.-Presto-Router$$anon$89.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$88() {
  this.bnS = null;
  this.bnK = null;
  this.bnL = false;
  this.bnT = null;
  this.bnU = false;
  this.bnX = null;
  this.bnQ = null;
  this.bnR = false;
  this.bnM = null;
  this.bnN = false;
  this.bnO = null;
  this.bnP = false;
  this.bnV = false;
  this.bnW = false;
  this.bnS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnX = "OystrAdminPage";
}
export { $c_Lpresto_PrestoRouter$$anon$88 as $c_Lpresto_PrestoRouter$$anon$88 };
$p = $c_Lpresto_PrestoRouter$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$88;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$88() {
}
export { $h_Lpresto_PrestoRouter$$anon$88 as $h_Lpresto_PrestoRouter$$anon$88 };
$h_Lpresto_PrestoRouter$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bnS;
});
$p.M = (function() {
  if ((!this.bnL)) {
    this.bnK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnL = true;
  }
  return this.bnK;
});
$p.O = (function() {
  if ((!this.bnU)) {
    this.bnT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnU = true;
  }
  return this.bnT;
});
$p.E = (function() {
  return this.bnX;
});
$p.t = (function() {
  if ((!this.bnR)) {
    this.bnQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnR = true;
  }
  return this.bnQ;
});
$p.N = (function() {
  if ((!this.bnN)) {
    this.bnM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnN = true;
  }
  return this.bnM;
});
$p.Q = (function() {
  if ((!this.bnP)) {
    this.bnO = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002489.$c_Lpresto_PrestoRouter$$anon$89();
    this.bnP = true;
  }
  return this.bnO;
});
$p.v = (function() {
  if ((!this.bnW)) {
    this.bnV = false;
    this.bnW = true;
  }
  return this.bnV;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee563) => ((p) => \u03b4scrutinee563))($j_presto$002e$002dOystr$002dAdmin$002dPage$0024.$m_Lpresto_OystrAdminPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$88, "presto.PrestoRouter$$anon$88", ({
  P6: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$88 as $d_Lpresto_PrestoRouter$$anon$88 };
//# sourceMappingURL=presto.-Presto-Router$$anon$88.js.map
